// Stripe.js (TMS-1789) is only needed on checkout pages, and Stripe requires it to be loaded
// from js.stripe.com rather than bundled, so it is added on demand. Repeated calls share one
// script tag and one Stripe instance per publishable key.
const STRIPE_JS_URL = "https://js.stripe.com/v3/"
let scriptPromise = null
const instances = new Map()

function loadScript() {
  if (window.Stripe) return Promise.resolve(window.Stripe)

  scriptPromise ||= new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = STRIPE_JS_URL
    script.async = true
    script.onload = () => (window.Stripe ? resolve(window.Stripe) : reject(new Error("Stripe.js did not load")))
    script.onerror = () => {
      scriptPromise = null
      reject(new Error("Stripe.js could not be loaded"))
    }
    document.head.appendChild(script)
  })
  return scriptPromise
}

export async function loadStripe(publishableKey) {
  const Stripe = await loadScript()
  if (!instances.has(publishableKey)) instances.set(publishableKey, Stripe(publishableKey))
  return instances.get(publishableKey)
}

// Stripe names card brands in lower case; the Hub shows the names Braintree used
// (Payments::Stripe::CARD_BRAND_LABELS), so the Store's Review step reads the same either way.
const CARD_BRAND_LABELS = {
  amex: "American Express",
  american_express: "American Express",
  cartes_bancaires: "Cartes Bancaires",
  diners: "Diners Club",
  discover: "Discover",
  eftpos_au: "eftpos",
  jcb: "JCB",
  mastercard: "MasterCard",
  unionpay: "UnionPay",
  visa: "Visa"
}

export function cardBrandLabel(brand) {
  if (!brand) return ""
  return CARD_BRAND_LABELS[brand.toLowerCase()] || brand
}
